import http from '../../../axios'

export let mt4_account_create = (params = '') =>
  http.post('/mt4-account/create', params)

export let get_mt4_account_list = (params = '') =>
  http.post('/mt4-account/list', params)

export let change_leverage = (params = '') =>
  http.post('/mt4-account/change-leverage', params)
